import { mdiImageOutline, mdiArrowRight } from "@mdi/js";
import React, { useState, useEffect, useRef } from "react";

// import Button from "../../../components/button/Button";
import OtpInput from "react-otp-input";
import { useLocation, useHistory, useParams } from "react-router-dom";
import HeaderBar from "../../../components/header/headerBar";
import { getLocalUrl } from "../../../functions";

import CountryPhoneInput, {
  CountryPhoneInputValue,
  ConfigProvider,
} from "antd-country-phone-input";
import en from "world_countries_lists/data/countries/en/world.json";
import "antd/dist/antd.css";
import "antd-country-phone-input/dist/index.css";

import {
  Input,
  Select,
  Button,
  Checkbox,
  DatePicker,
  Form,
  Row,
  Col,
  Upload,
  Image,
} from "antd";
import { Icon } from "@iconify/react";
import axios from "axios";
import moment from "moment";
import { useSelector, useDispatch } from "react-redux";
import { getFileHostUrl } from "../../../helpers/functions";
import { number } from "prop-types";

interface ParamTypes {
  id?: string;
}

const CreateNewOPD = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const { opd } = useSelector((state: any) => state);
  const inputFileImage: any = useRef();

  const { id } = useParams<ParamTypes>();
  const { RangePicker } = DatePicker;
  const { search } = useLocation();
  const [route, setRoute] = useState("");
  const [fileSelected, setFileSelected] = useState<string>("");

  const [nameErrors, setNameErrors] = useState<boolean>(false);
  const [opdPrintErrors, setOpdPrintErrors] = useState<boolean>(false);

  let [formList] = Form.useForm();
  const [optBranch, setOptBranch] = useState<any>([]);
  const [optTitles, setOptTitles] = useState<any>([]);
  const [optGender, setOptGender] = useState<any>([]);
  const [check, setCheck] = useState(false);
  const [customerTypes, setCustomerTypes] = useState<any>([]);
  const [provinceOption, setProvinceOption] = useState<any>([]);
  const [optCity, setOptCity] = useState<any>([]);
  const [optCityCard, setOptCityCard] = useState<any>([]);
  const [optSubCity, setOptSubCity] = useState<any>([]);
  const [optSubCityCard, setOptSubCityCard] = useState<any>([]);
  const [optPostalCode, setOptPostalCode] = useState<any>([]);
  const [optPostalCodeCard, setOptPostalCodeCard] = useState<any>([]);
  const [optAgencies, setOptAgencies] = useState<any>([]);
  const [optAgencyMembers, setOptAgencyMembers] = useState<any>([]);
  const [agencyId, setAgencyId] = useState<any>([]);
  const [optSale, setOptSale] = useState<any>([]);
  const [optCountry, setOptCountry] = useState<any>([]);
  const [fileList, setFileList] = useState<any>([]);
  const [isDisable, setIsDisable] = useState<any>([]);
  const [bloodType, setBloodType] = useState<any>([]);
  const [value1, setValue1] = useState<CountryPhoneInputValue>({
    short: "TH",
  });
  const [value2, setValue2] = useState<CountryPhoneInputValue>({
    short: "TH",
  });
  const [valuePhone1, setPhoneValue1] = useState<any>({});
  const [valuePhone2, setPhoneValue2] = useState<any>({});
  // check rule
  const [formFirstName, setformFirstName] = useState<string>("");
  const [formListName, setformListName] = useState<string>("");
  const [formNickName, setformNickName] = useState<string>("");
  const [formFirstNameENG, setformFirstNameENG] = useState<string>("");
  const [formListNameENG, setformListNameENG] = useState<string>("");
  const [formNickNameENG, setformNickNameENG] = useState<string>("");
  const [IdCardCheck, setformIdCardCheck] = useState<string>("");
  const [PassID, setformPassID] = useState<string>("");

  const dateFormat = "DD-MM-YYYY";
  const saveFormat = "YYYY-MM-DD";

  const useQuery = () => {
    const { search } = useLocation();

    return React.useMemo(() => new URLSearchParams(search), [search]);
  };

  let query = useQuery();

  const getQueryString = async () => {
    console.log("=>>>>>", query.get("idVip"));
    const idVip = query.get("idVip");
    if (idVip) {
      const dataVip = await axios.get(`/user-vip/${idVip}`);
      console.log("dataVip", dataVip?.data);
      if (dataVip?.data?.typeLang === "TH") {
        formList.setFieldsValue({
          firstName: dataVip?.data?.name,
          lastName: dataVip?.data?.surName,
        });
        setformFirstName(dataVip?.data?.name);
        setformListName(dataVip?.data?.surName);
      } else if (dataVip?.data?.typeLang === "EN") {
        formList.setFieldsValue({
          firstNameEN: dataVip?.data?.name,
          lastNameEN: dataVip?.data?.surName,
        });
        setformFirstNameENG(dataVip?.data?.name);
        setformListNameENG(dataVip?.data?.surName);
      }
    }
  };

  async function onSubmit(values: any) {
    const data = {
      ...values,
      phoneNumbersFirst: valuePhone1?.phone ? valuePhone1 : {},
      phoneNumbersSecond: valuePhone2?.phone ? valuePhone2 : {},
      customerType: id,
      date: values["date"]?.format(saveFormat),
      birthDate: values["birthDate"]?.format(saveFormat),
      isSameAddressIDCard: check,
    };
    console.log("data=>>>>>", data);

    dispatch({
      type: "CREATE_OPD",
      data: data,
    });

    setTimeout(() => {
      history.push(`${route}/emergency-contact`);
    }, 500);
  }

  const location = useLocation();

  const getBloodType = () => {
    const BType = [
      {
        _id: "A+",
        name: "A+",
      },
      {
        _id: "A-",
        name: "A-",
      },
      {
        _id: "B+",
        name: "B+",
      },
      {
        _id: "B-",
        name: "B-",
      },
      {
        _id: "AB+",
        name: "AB+",
      },
      {
        _id: "AB-",
        name: "AB-",
      },
      {
        _id: "O+",
        name: "O+",
      },
      {
        _id: "O-",
        name: "O-",
      },
    ];
    const bloodType = [];

    for (let i = 0; i < BType?.length; i++) {
      bloodType.push(
        <Select.Option value={BType[i]?._id} key={BType[i]?._id}>
          {BType[i]?.name}
        </Select.Option>
      );
    }

    setBloodType(bloodType);
  };

  const getCustomerTypes = async () => {
    await axios.get(`/customer-types/${id}`).then((res) => {
      setCustomerTypes(res?.data);
    });
  };

  const getBranches = async () => {
    await axios.get(`/branches`).then((res) => {
      let data = res?.data?.data;
      const branch = [];

      for (let i = 0; i < data?.length; i++) {
        branch.push(
          <Select.Option value={data[i]?._id} key={data[i]?._id}>
            {data[i]?.name}
          </Select.Option>
        );
      }

      setOptBranch(branch);
    });
  };

  const getCN = async (branchId: any) => {
    const data = await axios.get(
      `/member-opd/get-code?customerTypeId=${id}&branchId=${branchId}`
    );
    formList.setFieldsValue({
      codeCN: data?.data?.code,
    });
  };

  const getGender = async () => {
    const gender = await axios.get(`/genders`);
    let data = [];

    for (let i = 0; i < gender?.data?.data.length; i++) {
      data.push(
        <Select.Option
          value={gender?.data?.data[i]?._id}
          key={gender?.data?.data[i]?._id}
        >
          {gender?.data?.data[i]?.name}
        </Select.Option>
      );
    }

    setOptGender(data);
  };

  const getCountry = async () => {
    await axios.get(`/countries`).then((res) => {
      let data = res?.data?.data;
      // let data = [{
      //   "_id": "6268c5ce2ce542278b5ade88",
      //   "name": "ประเทศไทย"
      // }]
      const code = [];

      for (let i = 0; i < data.length; i++) {
        code.push(
          <Select.Option value={data[i]?._id} key={data[i]?._id}>
            {data[i]?.name}
          </Select.Option>
        );
      }
      setOptCountry(code);
    });
  };

  const getPrefixes = async () => {
    const titleName = await axios.get(`/prefixes`);
    const title = [];

    for (let i = 0; i < titleName?.data?.data.length; i++) {
      title.push(
        <Select.Option
          value={titleName?.data?.data[i]?._id}
          key={titleName?.data?.data[i]?._id}
        >
          {titleName?.data?.data[i]?.name}
        </Select.Option>
      );
    }
    setOptTitles(title);
  };

  const getProvinceThai = async () => {
    await axios.get(`/states`).then((res) => {
      let data = res?.data?.data;
      const province = [];

      for (let i = 0; i < data.length; i++) {
        province.push(
          <Select.Option value={data[i]?._id} key={data[i]?._id}>
            {data[i]?.name}
          </Select.Option>
        );
      }

      setProvinceOption(province);
    });
  };

  const getCities = async (id: any, state: any) => {
    await axios.get(`/cities?stateId=${id}`).then((res) => {
      let data = res?.data?.data;
      const city = [];

      for (let i = 0; i < data.length; i++) {
        city.push(
          <Select.Option value={data[i]?._id} key={data[i]?._id}>
            {data[i]?.name}
          </Select.Option>
        );
      }

      if (state === "city") {
        setOptCity(city);
      } else if (state === "cityCard") {
        setOptCityCard(city);
      }
    });
  };

  const getSubCities = async (id: any, state: any) => {
    await axios.get(`/sub-cities?cityId=${id}`).then((res) => {
      let data = res?.data?.data;
      const subCity = [];

      for (let i = 0; i < data.length; i++) {
        subCity.push(
          <Select.Option value={data[i]?._id} key={data[i]?._id}>
            {data[i]?.name}
          </Select.Option>
        );
      }

      if (state === "subCity") {
        setOptSubCity(subCity);
      } else if (state === "subCityCard") {
        setOptSubCityCard(subCity);
      }
    });
  };

  const getPostalCode = async (id: any, state: any) => {
    await axios.get(`/postal-codes?cityId=${id}`).then((res) => {
      let data = res?.data?.data;
      const code = [];

      for (let i = 0; i < data.length; i++) {
        code.push(
          <Select.Option value={data[i]?._id} key={data[i]?._id}>
            {data[i]?.name}
          </Select.Option>
        );
      }

      if (state === "postalCode") {
        setOptPostalCode(code);
      } else if (state === "postalCodeCard") {
        setOptPostalCodeCard(code);
      }
    });
  };

  const getAgencies = async (search: any) => {
    await axios.get(`/agencies?search=${search}`).then((res) => {
      let data = res?.data?.data;
      const code = [];

      for (let i = 0; i < data.length; i++) {
        code.push(
          <Select.Option value={data[i]?._id} key={data[i]?._id}>
            {data[i]?.name}
          </Select.Option>
        );
      }

      setOptAgencies(code);
    });
  };

  const getAgencyMembers = async (search: any) => {
    console.log("agencyId", agencyId);

    await axios
      .get(`/agencies/members?agencyId=${agencyId}&search=${search}`)
      .then((res) => {
        let data = res?.data?.data;
        const code = [];

        for (let i = 0; i < data.length; i++) {
          code.push(
            <Select.Option value={data[i]?._id} key={data[i]?._id}>
              {data[i]?.code} {data[i]?.name}
            </Select.Option>
          );
        }

        setOptAgencyMembers(code);
      });
  };

  const getPersonal = async (search: any) => {
    await axios.get(`/users?search=${search}`).then((res) => {
      let data = res?.data?.data;
      const code = [];

      console.log(data);

      for (let i = 0; i < data.length; i++) {
        code.push(
          <Select.Option value={data[i]?._id} key={data[i]?._id}>
            {data[i]?.code} {data[i]?.displayName}
          </Select.Option>
        );
      }

      setOptSale(code);
    });
  };

  const setHowOld = async (values: any) => {
    console.log("values=>>>>", values);
    if (values) {
      let difference = moment().diff(values);
      let duration = moment.duration(difference);
      formList.setFieldsValue({
        year: duration.years() + " Y",
        day: duration.days() + " D",
        month: duration.months() + " M",
      });
    } else {
      formList.setFieldsValue({
        year: "",
        day: "",
        month: "",
      });
    }
  };

  const getCountryCode = () => {
    // axios.get(`http://country.io/phone.json`).then((res) => {
    //   console.log("res", res);
    // });
  };

  const getStateOpd = async () => {
    if (opd?.date) {
      setCheck(opd?.isSameAddressIDCard);
      if (opd?.uploadImage?.file) {
        setFileList([opd?.uploadImage?.file]);
      }
      console.log(opd);

      setformFirstName(opd?.firstName);
      setformListName(opd?.lastName);
      setformNickName(opd?.nickName);
      setformFirstNameENG(opd?.firstNameEN);
      setformListNameENG(opd?.lastNameEN);
      setformNickNameENG(opd?.nickNameEN);
      setformIdCardCheck(opd?.idCard);
      setformPassID(opd?.passportID);
      if (opd?.phoneNumbersFirst) {
        setValue1(
          opd?.phoneNumbersFirst?.phone
            ? opd?.phoneNumbersFirst
            : { short: "TH" }
        );
      }
      setValue2(
        opd?.phoneNumbersSecond?.phone
          ? opd?.phoneNumbersSecond
          : { short: "TH" }
      );

      formList.setFieldsValue({
        addressNumber: opd?.addressNumber,
        agency: opd?.agency,
        agencySearch: opd?.agencySearch,
        birthDate: moment(opd?.birthDate),
        bloodPressure: opd?.bloodPressure,
        branch: opd?.branch,
        buildingName: opd?.buildingName,
        city: opd?.city,
        codeCN: opd?.codeCN,
        bloodtype: opd?.bloodtype,
        // companyRegisterNo: opd?.companyRegisterNo,
        country: opd?.country ? opd?.country : null,
        date: moment(opd?.date),
        day: opd?.day,
        email: opd?.email,
        firstName: opd?.firstName,
        firstNameEN: opd?.firstNameEN,
        gender: opd?.gender,
        height: opd?.height,
        idCard: opd?.idCard,
        lastName: opd?.lastName,
        lastNameEN: opd?.lastNameEN,
        lineId: opd?.lineId,
        middleNameEN: opd?.middleNameEN,
        month: opd?.month,
        moo: opd?.moo,
        nationality: opd?.nationality,
        nickNameEN: opd?.nickNameEN,
        nickName: opd?.nickName,
        passportID: opd?.passportID,
        personal: opd?.personal,
        // phoneNumbers: opd?.phoneNumbers,
        // phoneNumbersFirst: valuePhone1?.phone ? valuePhone2 : {},
        // phoneNumbersSecond: valuePhone2?.phone ? valuePhone2 : {},
        postalCode: opd?.postalCode,
        // printOpd: opd?.printOpd,
        race: opd?.race,
        road: opd?.road,
        soi: opd?.soi,
        state: opd?.state,
        subCity: opd?.subCity,
        title: opd?.title,
        weight: opd?.weight,
        year: opd?.year,
        uploadImage: opd?.uploadImage,
      });

      await setAgencyId(opd?.agencySearch);

      getAgencies("");
      getAgencyMembers("");
      getPersonal("");

      await getCities(opd?.state, "cityCard");
      await getSubCities(opd?.city, "subCityCard");
      await getPostalCode(opd?.city, "postalCodeCard");

      if (!opd?.isSameAddressIDCard) {
        formList.setFieldsValue({
          addressNumberPresent: opd?.addressNumberPresent,
          buildingNamePresent: opd?.buildingNamePresent,
          mooPresent: opd?.mooPresent,
          soiPresent: opd?.soiPresent,
          roadPresent: opd?.roadPresent,
          statePresent: opd?.statePresent,
          cityPresent: opd?.cityPresent,
          subCityPresent: opd?.subCityPresent,
          postalCodePresent: opd?.postalCodePresent,
          countryPresent: opd?.countryPresent,
        });

        await getCities(opd?.state, "city");
        await getSubCities(opd?.city, "subCity");
        await getPostalCode(opd?.city, "postalCode");
      }

      setIsDisable({
        ...isDisable,
        isAgency: true,
        cityCard: true,
        subCityCard: true,
        postalCodeCard: true,
        city: opd?.isSameAddressIDCard ? false : true,
        subCity: opd?.isSameAddressIDCard ? false : true,
        postalCode: opd?.isSameAddressIDCard ? false : true,
        isUpload: opd?.uploadImage ? false : true,
      });
    }
  };

  const onFileInputChange = (e: any) => {
    const { originFileObj } = e.file;

    const url = getLocalUrl(originFileObj);
    if (e?.file?.status !== "removed") {
      setFileList([
        {
          uid: "1",
          name: e?.file?.name,
          url: url,
        },
      ]);
    } else {
      formList.setFieldsValue({ uploadImage: null });
      setFileList([]);
    }
  };

  useEffect(() => {
    getQueryString();
    setIsDisable({ ...isDisable, isUpload: true });
    getStateOpd();
    getCountry();
    formList.setFieldsValue({
      date: moment(),
    });
    getCustomerTypes();
    setRoute(location.pathname);
    getBranches();
    getPrefixes();
    getGender();
    getProvinceThai();
    getBloodType();

    getCountryCode();
  }, []);

  useEffect(() => {
    if (check) {
      formList.setFieldsValue({
        addressNumberPresent: null,
        buildingNamePresent: null,
        mooPresent: null,
        soiPresent: null,
        roadPresent: null,
        statePresent: null,
        cityPresent: null,
        subCityPresent: null,
        postalCodePresent: null,
        countryPresent: null,
      });
    }
  }, [check]);
  useEffect(() => {
    console.log(formFirstName);
  }, [formFirstName]);
  const onKeydownCheck = (eveb: KeyboardEvent) => {
    if (eveb.keyCode !== 8) {
      eveb.preventDefault();
      // message.error("Please Input Max 10 ");
    }
  };
  const checkValue1 = (value: any) => {
    // console.log("value=>>", value);
    if (value?.phone) {
      setTimeout(() => {
        const setnumber =
          value?.phone.substring(0, 1) === "0"
            ? value?.phone.substring(1)
            : value?.phone;
        const body = {
          phone: setnumber,
          code: value.code,
          short: value.short,
        };
        // console.log(body);
        setPhoneValue1(body);
      }, 200);
    }
  };
  const checkValue2 = (value: any) => {
    // console.log("value=>>", value);
    if (value?.phone) {
      setTimeout(() => {
        const setnumber =
          value?.phone.substring(0, 1) === "0"
            ? value?.phone.substring(1)
            : value?.phone;
        const body = {
          phone: setnumber,
          code: value.code,
          short: value.short,
        };
        // console.log(body);
        setPhoneValue2(body);
      }, 200);
    }
  };

  return (
    <div>
      <HeaderBar
        title={`${customerTypes.name}`}
        onClick={() => history.push(`/opd/`)}
      />
      <div style={{ padding: "0px 80px" }}>
        <Form form={formList} onFinish={onSubmit}>
          <div
            className="create-page create-opd"
            style={{ padding: "30px 80px 50px" }}
          >
            <Row gutter={[16, 16]}>
              <Col span={8}>
                <div className="heading">
                  <p>รหัสลูกค้า/CN</p>
                </div>
                <Form.Item name="codeCN">
                  <Input disabled />
                </Form.Item>
              </Col>
              <Col span={8}>
                <div className="heading">
                  <p>สาขา/Branch</p>
                </div>
                <Form.Item
                  name="branch"
                  rules={[
                    {
                      required: true,
                      message: "กรุณาเลือก Branch!",
                    },
                  ]}
                >
                  <Select
                    className="selected-opd"
                    suffixIcon={<Icon icon="ant-design:caret-down-filled" />}
                    onChange={(e) => {
                      getCN(e);
                    }}
                  >
                    {optBranch}
                  </Select>
                </Form.Item>
              </Col>
              <Col span={8}>
                <div className="heading">
                  <p>วันที่สมัคร/Date</p>
                </div>
                <Form.Item name="date">
                  <DatePicker
                    inputReadOnly
                    disabled
                    format={dateFormat}
                    style={{
                      height: "auto",
                      width: "100%",
                      border: "none",
                      borderRadius: "0px",
                      borderBottom: "1px solid #d9d9d9",
                    }}
                  />
                </Form.Item>
              </Col>
            </Row>

            {/* <Row gutter={[16, 16]} style={{ marginTop:"20px"}}>
              <Col span={24}>
                <div className="heading">
                  <p>PRINT OPD<span>*</span></p>
                </div>
                <Form.Item name="printOpd"
                  rules={[{
                    required: true,
                    message: "กรุณากรอกข้อมูล!",
                  }]}
                >
                  <Select
                    className={`col-12 ${opdPrintErrors ? "ValidateForm" : ""}`}
                    mode="multiple"
                    showArrow={true}
                    maxTagCount="responsive"
                    suffixIcon={
                      <Icon
                        icon="ant-design:caret-down-filled"
                      />
                    }
                  >
                    {optBranch}
                  </Select>
                </Form.Item>
              </Col>
            </Row> */}

            <Row gutter={[16, 16]} style={{ marginTop: "20px" }}>
              <Col span={8}>
                <div className="heading">
                  <p>หน่วยงาน/Agency</p>
                </div>
                <Form.Item name="agencySearch">
                  <Select
                    className="col-12 search-one"
                    placeholder="Name"
                    suffixIcon={<Icon icon="ant-design:caret-down-filled" />}
                    showSearch
                    onSearch={getAgencies}
                    filterOption={false}
                    onChange={(e) => {
                      setAgencyId(e);
                      setIsDisable({ ...isDisable, isAgency: true });
                    }}
                  >
                    {optAgencies}
                  </Select>
                </Form.Item>
              </Col>
              <Col span={8} style={{ paddingTop: "25.4px" }}>
                <Form.Item
                  name="agency"
                  rules={[
                    {
                      required: false,
                      message: "กรุณาเลือกข้อมูล!",
                    },
                  ]}
                  className="selected-opd"
                >
                  <Select
                    className="col-12 search-one"
                    placeholder="ID/Name"
                    suffixIcon={<Icon icon="ant-design:caret-down-filled" />}
                    showSearch
                    filterOption={false}
                    onSearch={getAgencyMembers}
                    disabled={isDisable?.isAgency ? false : true}
                  >
                    {optAgencyMembers}
                  </Select>
                </Form.Item>
              </Col>
              <Col span={8}>
                <div className="heading">
                  <p>พนักงานขาย/Sale</p>
                </div>
                <Form.Item
                  name="personal"
                  rules={[
                    {
                      required: true,
                      message: "กรุณาเลือกข้อมูล!",
                    },
                  ]}
                >
                  <Select
                    showSearch
                    className="col-12 search-one"
                    placeholder="ID/Name"
                    filterOption={false}
                    suffixIcon={<Icon icon="ant-design:caret-down-filled" />}
                    onSearch={getPersonal}
                  >
                    {optSale}
                  </Select>
                </Form.Item>
              </Col>
            </Row>

            <div className="title-header">
              <h3>ข้อมูลส่วนตัว/Personal Information</h3>
              <Row gutter={[16, 16]} style={{ marginLeft: "0" }}>
                <Col span={6} className="pick-img" style={{ paddingLeft: "0" }}>
                  <Form.Item
                    name="uploadImage"
                    // rules={[
                    //   {
                    //     required: true,
                    //     message: "Attach Picture!",
                    //   },
                    // ]}
                    // valuePropName="fileList"
                  >
                    <Upload
                      listType="picture-card"
                      fileList={fileList}
                      onChange={(e) => {
                        onFileInputChange(e);
                        // if (e.fileList.length !== 0) {
                        //   setIsDisable({ ...isDisable, isUpload: false})
                        // }
                      }}
                      customRequest={({ onSuccess }: any) => {
                        onSuccess();
                      }}
                      // onRemove={(e) => {
                      //   setIsDisable({ ...isDisable, isUpload: true})
                      // }}
                      accept="image/*"
                    >
                      {fileList?.length < 1 && (
                        <>
                          <div className="icon-upload">
                            <Icon
                              icon="bxs:image-add"
                              width="1.5rem"
                              height="1.5rem"
                              style={{ marginLeft: "5px" }}
                            />
                          </div>
                        </>
                      )}
                    </Upload>
                    {/* <Image width={100} src={opd?.uploadImage?.fileList[0].originFileObj} /> */}
                  </Form.Item>
                </Col>
                <Col
                  span={18}
                  style={{
                    justifyContent: "space-between",
                    paddingRight: "0",
                    marginTop: "2rem",
                  }}
                >
                  <Row gutter={[16, 16]} className="data-personal">
                    <Col span={8}>
                      <Form.Item
                        name="title"
                        rules={[
                          {
                            required: true,
                            message: "กรุณากรอก คำนำหน้าชื่อ/TITLE!",
                          },
                        ]}
                      >
                        <Select
                          className="col-12"
                          placeholder="คำนำหน้าชื่อ/Title"
                          suffixIcon={
                            <Icon icon="ant-design:caret-down-filled" />
                          }
                        >
                          {optTitles}
                        </Select>
                      </Form.Item>
                    </Col>
                  </Row>
                  <Row gutter={[16, 16]} className="data-personal">
                    <Col span={8}>
                      <Form.Item
                        name="firstName"
                        rules={[
                          {
                            required: formFirstNameENG !== "" ? false : true,
                            message: "กรุณากรอก ชื่อ/Name!",
                          },
                        ]}
                      >
                        <Input
                          className={`${nameErrors ? "ValidateForm" : ""}`}
                          placeholder="ชื่อ/Name*"
                          onChange={(e) => {
                            setformFirstName(e.target.value);
                          }}
                        />
                      </Form.Item>
                    </Col>
                    <Col span={8}>
                      <Form.Item
                        name="lastName"
                        rules={[
                          {
                            required: formListNameENG !== "" ? false : true,
                            message: "กรุณากรอก นามสกุล/SurName!",
                          },
                        ]}
                      >
                        <Input
                          placeholder="นามสกุล/SurName*"
                          onChange={(e) => {
                            setformListName(e.target.value);
                          }}
                        />
                      </Form.Item>
                    </Col>
                    <Col span={8}>
                      <Form.Item
                        name="nickName"
                        rules={[
                          {
                            required: formNickNameENG !== "" ? false : true,
                            message: "กรุณากรอก ชื่อเล่น/NickName!",
                          },
                        ]}
                      >
                        <Input
                          placeholder="ชื่อเล่น/NickName"
                          onChange={(e) => {
                            setformNickName(e.target.value);
                          }}
                        />
                      </Form.Item>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </div>

            <Row gutter={[16, 16]} className="data-personal">
              <Col span={6}>
                <Form.Item
                  name="firstNameEN"
                  rules={[
                    {
                      required: formFirstName !== "" ? false : true,
                      message: "กรุณากรอก Name!",
                    },
                  ]}
                >
                  <Input
                    placeholder="Name"
                    onChange={(e) => {
                      setformFirstNameENG(e.target.value);
                    }}
                  />
                </Form.Item>
              </Col>
              <Col span={6}>
                <Form.Item name="middleNameEN">
                  <Input placeholder="Middle Name" />
                </Form.Item>
              </Col>
              <Col span={6}>
                <Form.Item
                  name="lastNameEN"
                  rules={[
                    {
                      required: formListName !== "" ? false : true,
                      message: "กรุณากรอก SurName!",
                    },
                  ]}
                >
                  <Input
                    placeholder="SurName"
                    onChange={(e) => {
                      setformListNameENG(e.target.value);
                    }}
                  />
                </Form.Item>
              </Col>
              <Col span={6}>
                <Form.Item
                  name="nickNameEN"
                  rules={[
                    {
                      required: formNickName !== "" ? false : true,
                      message: "กรุณากรอก NickName!",
                    },
                  ]}
                >
                  <Input
                    placeholder="NickName"
                    onChange={(e) => {
                      setformNickNameENG(e.target.value);
                    }}
                  />
                </Form.Item>
              </Col>
            </Row>

            <Row
              gutter={[16, 16]}
              className="data-personal"
              style={{ height: "52px" }}
            >
              <Col span={6}>
                <Form.Item name="birthDate">
                  <DatePicker
                    inputReadOnly
                    className="input-personnel"
                    placeholder="วันเกิด/Birth Date"
                    disabledDate={(d) => !d || d.isAfter(moment())}
                    format={dateFormat}
                    style={{
                      height: "auto",
                      width: "100%",
                      // border: "none",
                      // borderRadius: "0px",
                      // borderBottom: "2px solid #d9d9d9",
                    }}
                    onChange={setHowOld}
                  />
                </Form.Item>
              </Col>
              <Col span={2}>
                <Form.Item name="year">
                  <Input
                    placeholder="ปี/Year"
                    style={{ textAlign: "center" }}
                    disabled
                  />
                </Form.Item>
              </Col>
              <Col span={2}>
                <Form.Item name="month">
                  <Input
                    placeholder="เดือน/Month"
                    style={{ textAlign: "center" }}
                    disabled
                  />
                </Form.Item>
              </Col>
              <Col span={2}>
                <Form.Item name="day">
                  <Input
                    placeholder="วัน/Day"
                    style={{ textAlign: "center" }}
                    disabled
                  />
                </Form.Item>
              </Col>
              <Col span={6}>
                <Form.Item name="nationality">
                  <Input placeholder="สัญชาติ/Nationality" />
                </Form.Item>
              </Col>
              <Col span={6}>
                <Form.Item name="race">
                  <Input placeholder="เชื้อชาติ/Race" />
                </Form.Item>
              </Col>
            </Row>

            <Row>
              <Col>
                <div className="heading">
                  <p style={{ fontWeight: "inherit" }}>
                    เลขบัตรประชาชน/Identity No.<span>*</span>{" "}
                  </p>
                </div>
              </Col>
            </Row>

            <Row gutter={[16, 16]} className="data-personal">
              <Col span={12}>
                <Form.Item
                  name="idCard"
                  rules={[
                    {
                      required: PassID !== "" ? false : true,
                      message: "กรุณากรอก idCard!",
                    },
                  ]}
                >
                  <OtpInput
                    inputStyle={{
                      border: "1px solid #909090",
                      borderRadius: "8px",
                      width: "25px",
                      height: "25px",
                      fontSize: "16px",
                      color: "#333333",
                      fontWeight: "500",
                    }}
                    isInputNum
                    numInputs={13}
                    separator={<span style={{ width: "5px" }}></span>}
                    focusStyle={{
                      border: "1px solid #909090",
                      outline: "none",
                    }}
                    onChange={(e: any) => {
                      setformIdCardCheck(e);
                    }}
                  />
                </Form.Item>
              </Col>
              <Col span={6}></Col>
              <Col span={6}>
                {/* <Form.Item
                  name="companyRegisterNo"
                >
                  <Input type="text" placeholder="COMPANY REGISTRATION NO." />
                </Form.Item> */}

                <Form.Item
                  name="passportID"
                  rules={[
                    {
                      required: IdCardCheck !== "" ? false : true,
                      message: "กรุณากรอก Passport No.!",
                    },
                  ]}
                >
                  <Input
                    type="text"
                    placeholder="เลขพาสปอร์ต/Passport No."
                    style={{ textTransform: "uppercase" }}
                    onKeyDown={(e: any) => {
                      if (e.target.value.length >= 10) {
                        onKeydownCheck(e);
                      }
                    }}
                    onChange={(e: any) => {
                      setformPassID(e.target.value);
                    }}
                  />
                </Form.Item>
              </Col>
            </Row>

            <Row gutter={[16, 16]} className="data-personal">
              <Col span={6}>
                <Form.Item
                  name="gender"
                  rules={[
                    {
                      required: true,
                      message: "กรุณากรอก Gender!",
                    },
                  ]}
                >
                  <Select
                    className="col-12"
                    placeholder="เพศ/Gender*"
                    suffixIcon={<Icon icon="ant-design:caret-down-filled" />}
                  >
                    {optGender}
                  </Select>
                </Form.Item>
              </Col>
              <Col span={6}>
                <Form.Item
                  name="height"
                  rules={[
                    {
                      required: true,
                      message: "กรุณากรอก Height(cm.)!",
                    },
                  ]}
                >
                  <Input
                    placeholder="ส่วนสูง/Height(cm.)"
                    type="number"
                    onKeyDown={(e: any) => {
                      if (e.target.value.length > 2) {
                        onKeydownCheck(e);
                      }
                    }}
                  />
                </Form.Item>
              </Col>
              <Col span={6}>
                <Form.Item
                  name="weight"
                  rules={[
                    {
                      required: true,
                      message: "กรุณากรอก Weight(kg.)!",
                    },
                  ]}
                >
                  <Input
                    placeholder="น้ำหนัก/Weight(kg.)"
                    type="number"
                    onKeyDown={(e: any) => {
                      if (e.target.value.length > 2) {
                        onKeydownCheck(e);
                      }
                    }}
                  />
                </Form.Item>
              </Col>
              {/* <Col span={6}>
                <Form.Item
                  name="bloodPressure"
                  rules={[
                    {
                      required: true,
                      message: "กรุณากรอก BLOOD PRESSURE!",
                    },
                  ]}
                >
                  <Input placeholder="BLOOD PRESSURE (mm.Hg.)*" type="number" />
                </Form.Item>
              </Col> */}
              <Col span={6}>
                <Form.Item name="bloodtype">
                  <Select
                    placeholder="กรุ๊ปเลือด/Blood Type*"
                    suffixIcon={<Icon icon="ant-design:caret-down-filled" />}
                    // filterOption={(input: any, option: any) =>
                    //   option.children
                    //     .toLowerCase()
                    //     .indexOf(input.toLowerCase()) >= 0
                    // }
                    // showSearch
                  >
                    {bloodType}
                  </Select>
                </Form.Item>
              </Col>
            </Row>

            <Row gutter={[16, 16]} className="data-personal">
              <Col span={6}>
                <Form.Item
                  name="phoneNumbersFirst"
                  className="select-countrycode"
                >
                  {/* <Select
                    mode="tags"
                    className="col-12"
                    placeholder="MOBILE NO.*"
                    onKeyDown={(e: any) => {
                      if (e.target.value.length > 9) {
                        onKeydownCheck(e);
                      }
                    }}
                  ></Select> */}
                  {/* <Row justify="space-around">
                    <Col span={7}>
                      <Select
                        style={{ width: "100%" }}
                        suffixIcon={
                          <Icon icon="ant-design:caret-down-filled" />
                        }
                      ></Select>
                    </Col>
                    <Col span={17}>
                      <Input></Input>
                    </Col>
                  </Row> */}

                  <ConfigProvider locale={en}>
                    <CountryPhoneInput
                      style={{ marginTop: "0px" }}
                      placeholder="เบอร์ติดต่อหลัก/Primary Contact Number*"
                      type="number"
                      value={value1}
                      onChange={(v: any) => {
                        setValue1(v);
                        checkValue1(v);
                      }}
                      onKeyDown={(e: any) => {
                        if (e.target.value.length >= 10) {
                          onKeydownCheck(e);
                        }
                      }}
                    />
                  </ConfigProvider>
                </Form.Item>
              </Col>
              <Col span={6}>
                <Form.Item
                  name="phoneNumbersSecond"
                  className="select-countrycode"
                >
                  <ConfigProvider locale={en}>
                    <CountryPhoneInput
                      style={{ marginTop: "0px" }}
                      placeholder="เบอร์ติดต่อรอง/Secondary Contact Number*"
                      type="number"
                      value={value2}
                      onChange={(v: any) => {
                        setValue2(v);
                        checkValue2(v);
                      }}
                      onKeyDown={(e: any) => {
                        if (e.target.value.length >= 10) {
                          onKeydownCheck(e);
                        }
                      }}
                    />
                  </ConfigProvider>
                </Form.Item>
              </Col>
              <Col span={6} style={{ marginTop: "4px" }}>
                <Form.Item
                  name="email"
                  rules={[
                    {
                      required: true,
                      type: "email",
                      message: "กรุณากรอก อีเมล/E-Mail!",
                    },
                  ]}
                >
                  <Input placeholder="อีเมล์/E-Mail" />
                </Form.Item>
              </Col>
              <Col span={6} style={{ marginTop: "4px" }}>
                <Form.Item
                  name="lineId"
                  rules={[
                    {
                      required: true,
                      message: "กรุณากรอก Line ID!",
                    },
                  ]}
                >
                  <Input placeholder="ไอดีไลน์/Line ID" />
                </Form.Item>
              </Col>
            </Row>

            <div className="title-header">
              <h3 style={{ margin: "3px 0px 30px" }}>Address Information</h3>
            </div>

            <h5>Address as per ID Card (ที่อยู่ตามบัตรประชาชน)</h5>

            <Row
              gutter={[16, 16]}
              className="data-personal"
              style={{ marginTop: "30px" }}
            >
              <Col span={6}>
                <Form.Item
                  name="addressNumber"
                  rules={[
                    {
                      required: true,
                      message: "กรุณากรอกข้อมูล!",
                    },
                  ]}
                >
                  <Input placeholder="เลขที่/Number*" />
                </Form.Item>
              </Col>
              <Col span={6}>
                <Form.Item
                  name="buildingName"
                  rules={[
                    {
                      required: true,
                      message: "กรุณากรอกข้อมูล!",
                    },
                  ]}
                >
                  <Input placeholder="ชื่ออาคาร/Building" />
                </Form.Item>
              </Col>
              <Col span={6}>
                <Form.Item
                  name="moo"
                  rules={[
                    {
                      required: true,
                      message: "กรุณากรอกข้อมูล!",
                    },
                  ]}
                >
                  <Input placeholder="หมู่ที่/Village No." />
                </Form.Item>
              </Col>
              <Col span={6}>
                <Form.Item
                  name="soi"
                  rules={[
                    {
                      required: true,
                      message: "กรุณากรอกข้อมูล!",
                    },
                  ]}
                >
                  <Input placeholder="ซอย/Lane" />
                </Form.Item>
              </Col>
            </Row>

            <Row gutter={[16, 16]} className="data-personal">
              <Col span={6}>
                <Form.Item
                  name="road"
                  rules={[
                    {
                      required: true,
                      message: "กรุณากรอกข้อมูล!",
                    },
                  ]}
                >
                  <Input placeholder="ถนน/Road" />
                </Form.Item>
              </Col>
              <Col span={6}>
                <Form.Item
                  name="state"
                  rules={[
                    {
                      required: true,
                      message: "กรุณากรอกข้อมูล!",
                    },
                  ]}
                >
                  <Select
                    className="col-12"
                    placeholder="จังหวัด/Province*"
                    suffixIcon={<Icon icon="ant-design:caret-down-filled" />}
                    onChange={(e) => {
                      formList.setFieldsValue({
                        city: null,
                        subCity: null,
                        postalCode: null,
                      });
                      getCities(e, "cityCard");
                      setIsDisable({
                        ...isDisable,
                        cityCard: true,
                        subCityCard: false,
                        postalCodeCard: false,
                      });
                    }}
                    filterOption={(input: any, option: any) =>
                      option.children
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                    }
                    showSearch
                  >
                    {provinceOption}
                  </Select>
                </Form.Item>
              </Col>
              <Col span={6}>
                <Form.Item
                  name="city"
                  rules={[
                    {
                      required: true,
                      message: "กรุณากรอกข้อมูล!",
                    },
                  ]}
                  className="selected-opd"
                >
                  <Select
                    className="col-12"
                    placeholder="อำเภอ/เขต/District*"
                    suffixIcon={<Icon icon="ant-design:caret-down-filled" />}
                    disabled={isDisable?.cityCard ? false : true}
                    onChange={(e) => {
                      console.log(formList.isFieldTouched("stateCard"));
                      formList.setFieldsValue({
                        subCity: null,
                        postalCode: null,
                      });
                      getSubCities(e, "subCityCard");
                      getPostalCode(e, "postalCodeCard");
                      setIsDisable({
                        ...isDisable,
                        subCityCard: true,
                        postalCodeCard: true,
                      });
                    }}
                    filterOption={(input: any, option: any) =>
                      option.children
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                    }
                    showSearch
                  >
                    {optCityCard}
                  </Select>
                </Form.Item>
              </Col>
              <Col span={6}>
                <Form.Item
                  name="subCity"
                  rules={[
                    {
                      required: true,
                      message: "กรุณากรอกข้อมูล!",
                    },
                  ]}
                  className="selected-opd"
                >
                  <Select
                    className="col-12"
                    placeholder="ตำบล/แขวง/Sub-District*"
                    suffixIcon={<Icon icon="ant-design:caret-down-filled" />}
                    disabled={isDisable?.subCityCard ? false : true}
                    filterOption={(input: any, option: any) =>
                      option.children
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                    }
                    showSearch
                  >
                    {optSubCityCard}
                  </Select>
                </Form.Item>
              </Col>
            </Row>

            <Row gutter={[16, 16]} className="data-personal">
              <Col span={6}>
                <Form.Item
                  name="postalCode"
                  rules={[
                    {
                      required: true,
                      message: "กรุณากรอกข้อมูล!",
                    },
                  ]}
                  className="selected-opd"
                >
                  <Select
                    className="col-12"
                    placeholder="รหัสไปรษณีย์/Postal Code*"
                    suffixIcon={<Icon icon="ant-design:caret-down-filled" />}
                    disabled={isDisable?.postalCodeCard ? false : true}
                    filterOption={(input: any, option: any) =>
                      option.children
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                    }
                    showSearch
                  >
                    {optPostalCodeCard}
                  </Select>
                </Form.Item>
              </Col>
              <Col span={6}>
                <Form.Item
                  name="country"
                  rules={[
                    {
                      required: true,
                      message: "กรุณากรอกข้อมูล!",
                    },
                  ]}
                >
                  <Select
                    className="col-12"
                    placeholder="ประเทศ/Country"
                    suffixIcon={<Icon icon="ant-design:caret-down-filled" />}
                    filterOption={(input: any, option: any) =>
                      option.children
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                    }
                    showSearch
                  >
                    {optCountry}
                  </Select>
                </Form.Item>
              </Col>
            </Row>

            <h5 style={{ marginTop: "3px" }}>
              Present Address (ที่อยู่ปัจจุบัน)
            </h5>

            <Checkbox
              checked={check}
              style={{ marginTop: "10px" }}
              onChange={(e) => {
                setCheck(e.target.checked);
              }}
            >
              เหมือนที่อยู่ตามบัตรประชาชน/Same as the address on the ID card
            </Checkbox>

            {!check && (
              <>
                <Row
                  gutter={[16, 16]}
                  className="data-personal"
                  style={{ marginTop: "30px" }}
                >
                  <Col span={6}>
                    <Form.Item
                      name="addressNumberPresent"
                      rules={[
                        {
                          required: !check,
                          message: "กรุณากรอกข้อมูล!",
                        },
                      ]}
                    >
                      <Input placeholder="เลขที่/Number" />
                    </Form.Item>
                  </Col>
                  <Col span={6}>
                    <Form.Item
                      name="buildingNamePresent"
                      rules={[
                        {
                          required: !check,
                          message: "กรุณากรอกข้อมูล!",
                        },
                      ]}
                    >
                      <Input placeholder="ชื่ออาคาร/Building" />
                    </Form.Item>
                  </Col>
                  <Col span={6}>
                    <Form.Item
                      name="mooPresent"
                      rules={[
                        {
                          required: !check,
                          message: "กรุณากรอกข้อมูล!",
                        },
                      ]}
                    >
                      <Input placeholder="หมู่ที่/Village No." type="number" />
                    </Form.Item>
                  </Col>
                  <Col span={6}>
                    <Form.Item
                      name="soiPresent"
                      rules={[
                        {
                          required: !check,
                          message: "กรุณากรอกข้อมูล!",
                        },
                      ]}
                    >
                      <Input placeholder="Lane/ซอย" />
                    </Form.Item>
                  </Col>
                </Row>

                <Row gutter={[16, 16]} className="data-personal">
                  <Col span={6}>
                    <Form.Item
                      name="roadPresent"
                      rules={[
                        {
                          required: !check,
                          message: "กรุณากรอกข้อมูล!",
                        },
                      ]}
                    >
                      <Input placeholder="ถนน/Road" />
                    </Form.Item>
                  </Col>
                  <Col span={6}>
                    <Form.Item
                      name="statePresent"
                      rules={[
                        {
                          required: !check,
                          message: "กรุณากรอกข้อมูล!",
                        },
                      ]}
                    >
                      <Select
                        className="col-12"
                        placeholder="จังหวัด/Province*"
                        suffixIcon={
                          <Icon icon="ant-design:caret-down-filled" />
                        }
                        onChange={(e) => {
                          formList.setFieldsValue({
                            cityPresent: null,
                            subCityPresent: null,
                            postalCodePresent: null,
                          });
                          getCities(e, "city");
                          setIsDisable({
                            ...isDisable,
                            city: true,
                            subCity: false,
                            postalCode: false,
                          });
                        }}
                        filterOption={(input: any, option: any) =>
                          option.children
                            .toLowerCase()
                            .indexOf(input.toLowerCase()) >= 0
                        }
                        showSearch
                      >
                        {provinceOption}
                      </Select>
                    </Form.Item>
                  </Col>
                  <Col span={6}>
                    <Form.Item
                      name="cityPresent"
                      rules={[
                        {
                          required: !check,
                          message: "กรุณากรอกข้อมูล!",
                        },
                      ]}
                      className="selected-opd"
                    >
                      <Select
                        className="col-12"
                        placeholder="อำเภอ/เขต/District*"
                        suffixIcon={
                          <Icon icon="ant-design:caret-down-filled" />
                        }
                        disabled={isDisable?.city ? false : true}
                        onChange={(e) => {
                          formList.setFieldsValue({
                            subCityPresent: null,
                            postalCodePresent: null,
                          });
                          getSubCities(e, "subCity");
                          getPostalCode(e, "postalCode");
                          setIsDisable({
                            ...isDisable,
                            subCity: true,
                            postalCode: true,
                          });
                        }}
                        filterOption={(input: any, option: any) =>
                          option.children
                            .toLowerCase()
                            .indexOf(input.toLowerCase()) >= 0
                        }
                        showSearch
                      >
                        {optCity}
                      </Select>
                    </Form.Item>
                  </Col>
                  <Col span={6}>
                    <Form.Item
                      name="subCityPresent"
                      rules={[
                        {
                          required: !check,
                          message: "กรุณากรอกข้อมูล!",
                        },
                      ]}
                      className="selected-opd"
                    >
                      <Select
                        className="col-12"
                        placeholder="ตำบล/แขวง/Sub-District*"
                        suffixIcon={
                          <Icon icon="ant-design:caret-down-filled" />
                        }
                        disabled={isDisable?.subCity ? false : true}
                        filterOption={(input: any, option: any) =>
                          option.children
                            .toLowerCase()
                            .indexOf(input.toLowerCase()) >= 0
                        }
                        showSearch
                      >
                        {optSubCity}
                      </Select>
                    </Form.Item>
                  </Col>
                </Row>

                <Row gutter={[16, 16]} className="data-personal">
                  <Col span={6}>
                    <Form.Item
                      name="postalCodePresent"
                      rules={[
                        {
                          required: !check,
                          message: "กรุณากรอกข้อมูล!",
                        },
                      ]}
                      className="selected-opd"
                    >
                      <Select
                        className="col-12"
                        placeholder="รหัสไปรษณีย์/Postal Code*"
                        suffixIcon={
                          <Icon icon="ant-design:caret-down-filled" />
                        }
                        disabled={isDisable?.postalCode ? false : true}
                        filterOption={(input: any, option: any) =>
                          option.children
                            .toLowerCase()
                            .indexOf(input.toLowerCase()) >= 0
                        }
                        showSearch
                      >
                        {optPostalCode}
                      </Select>
                    </Form.Item>
                  </Col>
                  <Col span={6}>
                    <Form.Item
                      name="countryPresent"
                      rules={[
                        {
                          required: !check,
                          message: "กรุณากรอกข้อมูล!",
                        },
                      ]}
                    >
                      <Select
                        className="col-12"
                        placeholder="ประเทศ/Country"
                        suffixIcon={
                          <Icon icon="ant-design:caret-down-filled" />
                        }
                        filterOption={(input: any, option: any) =>
                          option.children
                            .toLowerCase()
                            .indexOf(input.toLowerCase()) >= 0
                        }
                        showSearch
                      >
                        {optCountry}
                      </Select>
                    </Form.Item>
                  </Col>
                </Row>
              </>
            )}
          </div>

          <div className="btn-confirm">
            <Form.Item colon={false}>
              <Button type="primary" htmlType="submit">
                Emergency Contact Name
                <Icon
                  icon="akar-icons:arrow-right"
                  width="1.2rem"
                  height="1.2rem"
                  style={{ marginLeft: "5px" }}
                />
              </Button>
            </Form.Item>
          </div>
        </Form>
      </div>
    </div>
  );
};
export default CreateNewOPD;
